import { api } from "@api/api";
import { IntegrationCatalog } from "@modules/erpIntegrations/types";
import { IntegrationFormValues } from "@modules/erpIntegrations/validations";

export async function editIntegrationService(
  id: string,
  data: Partial<IntegrationFormValues>
): Promise<IntegrationCatalog> {
  const { data: integration } = await api.patch<IntegrationCatalog>(
    `/v1/integration_admin/${id}/`,
    {
      name: data.name,
      description: data.description ?? "",
      documentation_url: data.documentation_url ?? "",
      instructions: data.instructions ?? "",
      auth_endpoint: data.auth_endpoint ?? null,
      auth_token_response_key: data.auth_token_response_key ?? "",
      features: data.features ?? [],
      active: data.active ?? true,
      credential_schema: data.credential_schema ?? [],
    }
  );

  return integration;
}

export async function patchIntegrationInstructions(
  id: number,
  instructions: string
): Promise<IntegrationCatalog> {
  const { data: integration } = await api.patch<IntegrationCatalog>(
    `/v1/integration_admin/${id}/`,
    { instructions }
  );

  return integration;
}
